import { ComponentRef, Injectable, ViewContainerRef, DestroyRef, EnvironmentInjector, inject } from '@angular/core';
import { MobileFullScreenComponent } from '../components/mobile-full-screen/mobile-full-screen.component';

@Injectable({
  providedIn: 'root'
})
export class MobileFullScreenService {
  private destroyRef = inject(DestroyRef);
  private environmentInjector = inject(EnvironmentInjector);

  componentRef!: ComponentRef<MobileFullScreenComponent>;

  openInFullScreen<T>
    (placeToRenderRef: ViewContainerRef, viewContainerRef: ViewContainerRef, componentToResolve: any, inputData?: any): ComponentRef<T> {

    const createdComponent = viewContainerRef.createComponent<T>(componentToResolve, {
      environmentInjector: this.environmentInjector
    });

    if (inputData && createdComponent.setInput) {
      Object.entries(inputData).forEach(([key, value]) => {
        createdComponent.setInput(key, value);
      });
    } else if (inputData && createdComponent.instance) {
      // Fallback: Direct property assignment for signal-based inputs
      Object.entries(inputData).forEach(([key, value]) => {
        const inputKey = key.endsWith('Input') ? key : `${key}Input`;
        if (typeof (createdComponent.instance as any)[inputKey] === 'function') {
          (createdComponent.instance as any)[inputKey].set(value);
        } else if (createdComponent.instance && typeof createdComponent.instance === 'object' && key in createdComponent.instance) {
          (createdComponent.instance as any)[key] = value;
        }
      });
    }

    placeToRenderRef.clear();
    this.componentRef = placeToRenderRef.createComponent(MobileFullScreenComponent, {
      projectableNodes: [[createdComponent.location.nativeElement]]
    });

    const subscription = this.componentRef.instance.close$.subscribe(() => {
      this.componentRef.destroy();
    });

    // Auto-cleanup when service is destroyed
    this.destroyRef.onDestroy(() => {
      subscription.unsubscribe();
      if (this.componentRef) {
        this.componentRef.destroy();
      }
    });

    return createdComponent;
  }
}
